import { commonCodesGetCommonCode } from "@/utils/commonCodes";

export function getCommonCodeName(code, value) {
    if (value.length === 0) {
        return null;
    }
    return commonCodesGetCommonCode(code)
        .filter((data) => {
            if (value.includes(data.comCode)) {
                return true;
            }
            return false;
        })
        .map((data) => data.comName);
}
export function getDataRangeValue(value) {
    if (!value.from || !value.to) {
        return null;
    }
    return value.from + "~" + value.to;
}

export const visitSearchNameObj = {
    visitInfo: {
        title: "내장정보",
        memberDiv: {
            title: "회원구분",
            code: "MEMBER_DIV",
            value: null,
            set dataSet(v) {
                this.value = getCommonCodeName(this.code, v);
            },
        },
        sexCode: {
            title: "성별",
            code: "SEX_CODE",
            value: null,
            set dataSet(v) {
                this.value = getCommonCodeName(this.code, v);
            },
        },
        ageCodes: {
            title: "연령대",
            code: "AGE_DISTRB",
            value: null,
            set dataSet(v) {
                this.value = getCommonCodeName(this.code, v);
            },
        },
        hp4: {
            title: "핸드폰 뒤 4자리",
            code: null,
            value: null,
            set dataSet(v) {
                this.value = v;
            },
        },
        visitDate: {
            title: "내장일자",
            code: null,
            value: null,
            set dataSet(v) {
               this.value = getDataRangeValue(v);
            },
        },
        visitTime: { title: "내장시간" },
        visitStartTime: {
            title: "내장시간 - 시작",
            code: null,
            value: null,
            set dataSet(v) {
                this.value = v;
            },
        },
        visitEndTime: {
            title: "내장시간 - 종료",
            code: null,
            value: null,
            set dataSet(v) {
                this.value = v;
            },
        },
        bsnCode: {
            title: "영업구분",
            code: "BSN_CODE",
            value: null,
            set dataSet(v) {
                this.value = getCommonCodeName(this.code, v);
            },
        },
        dwCode: {
            title: "요일",
            code: "DW_CODE",
            value: null,
            set dataSet(v) {
                this.value = getCommonCodeName(this.code, v);
            },
        },
        visitCnt: {
            title: "내장횟수",
            code: null,
            value: null,
            set dataSet(v) {
                this.value = v;
            },
        },
    },

    // exclude: {
    //     title: "제외",
    //     members: {
    //         title: "회원",
    //         code: null,
    //         value: null,
    //         set dataSet(v) {
    //             const vm = v.map(item => item.memberName || "");
    //             this.value = vm.length > 0 ? vm : null;
    //         },
    //     },
    // },
};
